<template>
  <aside class="legacy-platform-notice" aria-label="Legacy platform end of support">
    <p class="legacy-platform-notice__content">
      Support for this platform ends on&nbsp;<strong>August 15, 2026.</strong>&nbsp;Please move to
      the new platform:&nbsp;<a
        href="https://platform.oversecured.com/"
        target="_blank"
        rel="noopener noreferrer"
        >platform.oversecured.com</a
      >.&nbsp;For details, contact your account manager or email&nbsp;<a
        href="mailto:support@oversecured.com"
        >support@oversecured.com</a
      >.
    </p>
  </aside>
</template>

<script>
export default {
  name: 'LegacyPlatformNotice',
};
</script>

<style lang="scss" scoped>
.legacy-platform-notice {
  width: 100%;
  padding: 12px 24px;
  background: #fff4e5;
  border-bottom: 1px solid #f3c77b;
  color: #563900;

  &__content {
    max-width: 1280px;
    margin: 0 auto;
    font-size: 14px;
    line-height: 1.5;
    text-align: center;
  }

  a {
    color: #174ea6;
    font-weight: 600;
    text-decoration: underline;
    text-underline-offset: 2px;

    &:hover {
      color: #0b3577;
    }
  }
}

@media (max-width: 480px) {
  .legacy-platform-notice {
    padding: 10px 16px;

    &__content {
      font-size: 13px;
      text-align: left;
    }
  }
}
</style>
